<template>
  <v-container id="contact-detail" fluid tag="section">
    <base-material-card v-if="loadedContact" outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Thông tin khách hàng</div>
      </template>
      <v-tabs class="mt-3" color="primary">
        <v-tab v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
      </v-tabs>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="header-group-btn header-group-btn--modify">
          <!-- <v-btn color="info" class="mr-3" dark @click="clickAddOrder" v-if="checkConditionT4NT5(_.get(dataForm, 'contactStatus.type', '')) && !checkIncludesT4NT5(_.get(dataForm, 'contactStatus.type', ''))">
            <v-icon>mdi-plus</v-icon>Tạo đơn hàng mới
          </v-btn> -->
          <!-- <v-btn color="info" class="mr-3" dark @click="clickAddOrder"> -->
          <v-btn
            color="info"
            class="mr-3"
            dark
            @click="clickAddOrder"
            v-if="checkConditionT4NT5(_.get(dataForm, 'contactStatus.type', '')) && checkAuthorization('order_create') && checkNotIncludesM(dataForm.contactStatus.type)">
            <v-icon>mdi-plus</v-icon>Tạo đơn hàng mới
          </v-btn>
          <v-btn
            class="mr-3"
            color="success"
            @click.prevent="handleSubmit(clickUpdateContact); scrollToError()"
            v-if="checkAuthorization('contact_update')"
          >Lưu Lại</v-btn>
          <v-btn color="primary" @click="clickCancel">Huỷ Bỏ</v-btn>
        </div>
        <v-row class="px-4">
          <v-col cols="12" sm="4">
            <contact-detail-card
              :title-contact="'CONTACT'"
              :data-form="dataForm"
              :showChat="showChat"
              :contactColumns="contactColumns"
              :listPhoneRelated="listPhoneRelated"
            />
            <contact-detail-card
              v-if="parentCustomersLength === 0"
              :indexCustomer="-1"
              :data-form="dataForm"
              :title-contact="'PARENT'"
              :contactColumns="contactColumns"
            />
            <template
              v-for="(customer, index) in dataForm.customers.filter(customer => customer.position !== 'child' && !_.get(customer,'isDeleted', false))"
            >
              <contact-detail-card
                :key="'customer-parent-' + index"
                :customer="customer"
                :indexCustomer="index"
                :data-form="dataForm"
                :title-contact="'PARENT'"
                :contactColumns="contactColumns"
              />
            </template>
          </v-col>
          <v-col cols="12" sm="4">
            <contact-detail-card
              v-if="childCustomersLength === 0"
              :indexCustomer="-1"
              :title-contact="'CHILD'"
              :data-form="dataForm"
              :contactColumns="contactColumns"
            />
            <template
              v-for="(customer, index) in dataForm.customers.filter(customer => customer.position === 'child' && !_.get(customer,'isDeleted', false))"
            >
              <contact-detail-card
                v-if="showChild"
                :key="'customer-child-' + index"
                :customer="customer"
                :indexCustomer="index"
                :title-contact="'CHILD'"
                :data-form="dataForm"
                :contactColumns="contactColumns"
              />
            </template>
          </v-col>
          <v-col cols="12" sm="4">
            <contact-detail-card
              :title-contact="'CUSTOMER'"
              :contact-sources="contactSources"
              :users="users"
              :product-groups="productGroups"
              :data-form="dataForm"
              :contactColumns="contactColumns"
              :contactStatusList="contactStatusList"
              :schoolLevels="schoolLevels"
              :types="types"
            />
          </v-col>
        </v-row>
      </validation-observer>
    </base-material-card>
  </v-container>
</template>

<script>
import ContactDetailCard from './components/ContactDetailCard';
import RepositoryFactory from '../../repositories/RepositoryFactory';
import { contactDetailTabMenu } from '../../helpers/constants';

const ContactSourceRepository = RepositoryFactory.get('contact_source');
const ProductGroupRepository = RepositoryFactory.get('product_group');
const ContactRepository = RepositoryFactory.get('contact');
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const SchoolLevelRepository = RepositoryFactory.get('school_level');
const TypeRepository = RepositoryFactory.get('type');

export default {
  components: { ContactDetailCard },
  data() {
    return {
      combos: [],
      products: [],
      contactSources: [],
      showModalCall: false,
      showConfirm: false,
      users: [],
      productGroups: [],
      dataForm: {},
      loadedContact: false,
      tabs: [],
      contactColumns: {},
      contactStatusList: [],
      showChild: true,
      checkSources: ["Bot.hana.ai", "FAI", "FBCM", "FBCL"],
      showChat: false,
      listPhoneRelated: '',
      schoolLevels: [],
      types: [],
      watchModule: ''
    };
  },
  computed: {
    childCustomersLength() {
      return this.dataForm.customers.filter(
        customer =>
          customer.position === 'child' && !_.get(customer, 'isDeleted', false)
      ).length;
    },
    parentCustomersLength() {
      return this.dataForm.customers.filter(
        customer =>
          customer.position !== 'child' && !_.get(customer, 'isDeleted', false)
      ).length;
    }
  },
  async created() {
    const contactId = _.get(this, '$route.params.id', '');
    this.tabs = contactDetailTabMenu(contactId);
    this.dataForm = {
      order: {},
      // Main Contact
      position: 'other',
      // End Main Contact
      // Định Vị Khách Hàng
      contactSourceIds: [],
      groupIds: [],
      customers: [
        {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        }
      ]
    };
    const loader = this.$loading.show();
    await Promise.all([
      this.getContactDetail(),
      this.getProductGroups(),
      this.getUsers(),
      this.getContactSources(),
      this.getContactColumns(),
      this.getContactStatusList(),
      this.getListSchoolLevel(),
      this.getListType()
    ]);
    loader.hide();
    Bus.$on('contact-change-postion', () => {
       // render child again
      this.showChild = false;
      setTimeout(() => {
        this.showChild = true;
      }, 10);
    });
    Bus.$on('merge-contact', () => {
      this.getContactDetail()
    })

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.getUsers()
        this.getProductGroups()
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('contact-change-postion');
    this.watchModule()
  },
  methods: {
    async getContactStatusList() {
      const loading = this.$loading.show();
      const response = await ContactStatusRepository.list({});
      loading.hide();
      if (response.success) {
        const contactStatusList = [];
        _.get(response, 'data', []).forEach(contactStatus => {
          _.get(contactStatus, 'data', []).forEach(data => {
            contactStatusList.push({
              type: contactStatus.type,
              id: _.get(data, 'id', 0),
              name: _.get(data, 'name', 0),
            });
          });
        });
        this.contactStatusList = contactStatusList;
      } else {
        this.contactStatusList = [];
      }
    },
    async getContactColumns() {
      const response = await ContactRepository.getContactColumns();
      this.loading = false;
      if (response.success) {
        this.contactColumns = _.get(response, 'data', {});
      } else {
        this.contactColumns = {};
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    },
    clickAddOrder() {
      let self = this
      if (this.dataForm.mainId) {
        this.$swal({
          title: 'Số điện thoại đã được gộp vào contact ' + self.dataForm.phoneRelated[0] + '.<br>Vui lòng thực hiện các thao tác tại contact chính.',
          confirmButtonText: 'Xem contact chính',
          showCancelButton: true,
          cancelButtonText: 'Quay lại'
        }).then((res) => {
          if (res.value) {
            let routeData = self.$router.resolve({
              name: 'ContactDetail',
              params: {
                id: self.dataForm.mainId || 0
              }
            })
            window.open(routeData.href, '_blank')
          }
        })
      } else {
        // this.$router.push({
        //   name: 'OrderCreate',
        //   params: { id: _.get(this, '$route.params.id', '') }
        // });
        const id = _.get(this, '$route.params.id', '')
        // if((this.$store.state.module.typeId && this.$store.state.module.typeId == 2)) {
        //   this.$router.push({name: 'OrderTutorCreate', params: { id: id }});
        // }else {
        //   this.$router.push({name: 'OrderCreate', params: { id: id }});
        // }
        this.$router.push({name: 'OrderCreate', params: { id: id }});
      }
    },
    checkDuplicateCustomer() {
      let checkObjectChild = {};
      let checkObjectNotChild = {};
      // let statusChildError = false;
      // this.dataForm.customers.forEach(dataCustomer => {
      //   if (!_.get(dataCustomer, 'isDeleted', false)) {
      //     const position = _.get(dataCustomer, 'position', 'other');
      //     if (position === 'child') {
      //       const keyChild =
      //         dataCustomer.birthday + '-' + _.trim(dataCustomer.fullName).toLocaleLowerCase();
      //       if (checkObjectChild[keyChild]) {
      //         statusChildError = true;
      //       }
      //       checkObjectChild[keyChild] = true;
      //     } else {
      //       if (!checkObjectNotChild[position]) {
      //         checkObjectNotChild[position] = 0;
      //       }
      //       checkObjectNotChild[position] += 1;
      //     }
      //   }
      // });
      // if (statusChildError) {
      //   return 'Thông tin con bị trùng !!!';
      // }
      if (checkObjectNotChild['father'] > 1) {
        return 'Thông tin bố đã tồn tại';
      }
      if (checkObjectNotChild['mother'] > 1) {
        return 'Thông tin mẹ đã tồn tại';
      }
      return '';
    },
    async clickUpdateContact() {
      let checkDuplicateCustomer = this.checkDuplicateCustomer();
      if (checkDuplicateCustomer) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: checkDuplicateCustomer
        });
      }
      const dataUpdate = {
        statusId: _.get(this.dataForm, 'statusId', null),
        userId: _.get(this.dataForm, 'userId', null),
        productGroups: _.get(this.dataForm, 'productGroups', []),
        userMarketingName: _.trim(this.dataForm.userMarketingName),
        contactSourceIds: _.get(this.dataForm, 'contactSourceIds', []),
        schoolLevelId: _.get(this.dataForm, 'schoolLevelId', null),
        typeId: _.get(this.dataForm, 'typeId', null),
        description: _.trim(this.dataForm.description),
        customers: [],
        dynamicColumns:
          _.get(this.contactColumns, 'contact', []).map(dataAttribute => {
            return {
              columnId: dataAttribute.id,
              value: _.trim(this.dataForm[dataAttribute.id])
            };
          }) || []
      };
      let checkErrorPhone = false;
      dataUpdate.customers = this.dataForm.customers.map(customer => {
        const customerTemp = _.cloneDeep({ ...customer });
        const customerTempMobile = customerTemp.mobile;
        let customerId = _.get(customer, 'isNew', true)
          ? null
          : (customerId = _.get(customer, 'customerId', null));
        if (
          !_.get(customer, 'isMainCustomer', false) &&
          customerTemp.mobile &&
          customerTemp.mobile !== ''
        ) {
          if (!Array.isArray(customerTemp.phones)) {
            customerTemp.phones = [];
          }
          customerTemp.phones.unshift(customerTemp.mobile);
          customerTemp.mobile = '';
        }

        if (customerTemp.phoneSub) {
          if (customerTemp.phoneSub === customerTempMobile) {
            checkErrorPhone = true;
          }
          customerTemp.phones.push(customerTemp.phoneSub);
        }

        if (customerTemp.birthday < 1900) {
          customerTemp.birthday = null;
        }

        if (!customerTemp.positionTitle) {
          customerTemp.positionTitle = 'Khác';
        }

        if (
          _.get(customerTemp, 'isMainCustomer', false) &&
          !_.get(customerTemp, 'fullName', '')
        ) {
          customerTemp.fullName = _.get(customerTemp, 'mobile', '');
        }

        let dynamicColumns = [];
        if (_.get(customerTemp, 'isMainCustomer', false)) {
          dynamicColumns =
            _.get(this.contactColumns, 'main_customer', []).map(
              dataAttribute => {
                return {
                  columnId: dataAttribute.id,
                  value: _.trim(customerTemp[dataAttribute.id])
                };
              }
            ) || [];
        }

        let typeColumn =
          _.get(customer, 'position', 'other') === 'child' ? 'child' : 'parent';
        dynamicColumns = dynamicColumns.concat(
          _.get(this.contactColumns, typeColumn, []).map(dataAttribute => {
            return {
              columnId: dataAttribute.id,
              value: _.trim(customerTemp[dataAttribute.id])
            };
          }) || []
        );

        return {
          customerId,
          isDeleted: _.get(customerTemp, 'isDeleted', false),
          mobile: _.get(customerTemp, 'mobile', ''),
          isMainCustomer: _.get(customerTemp, 'isMainCustomer', false),
          fullName: _.trim(customerTemp.fullName),
          birthday: _.get(customerTemp, 'birthday', null),
          birthdayDescription: _.trim(customer.birthdayDescription),
          email: _.get(customerTemp, 'email', ''),
          capability: _.trim(customerTemp.capability),
          position: _.get(customerTemp, 'position', 'other'),
          positionTitle: _.trim(customerTemp.positionTitle) || 'Khác',
          tinhId: _.get(customerTemp, 'tinhId', 0) || 0,
          huyenId: _.get(customerTemp, 'huyenId', 0) || 0,
          xaId: _.get(customerTemp, 'xaId', 0) || 0,
          detailAddress: _.trim(customerTemp.detailAddress),
          description: _.trim(customerTemp.description),
          phones: _.get(customerTemp, 'phones', []),
          productDescription: _.trim(customer.productDescription),
          dynamicColumns
        };
      });
      if (checkErrorPhone) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: "Số điện thoại phụ không được giống số điện thoại chính",
        });
      }
      this.loading = this.$loading.show();
      const response = await ContactRepository.update(
        dataUpdate,
        this.$route.params.id
      );
      this.loading.hide();
      if (response.error) {
        if (this.dataForm.contactType == "sub") {
          this.$swal({
            title: _.get(response.errors, 'message', ''),
            confirmButtonText: 'Xem contact chính',
            showCancelButton: true,
            cancelButtonText: 'Quay lại'
          }).then((res) => {
            if (res.value) {
              let routeData = this.$router.resolve({
                name: 'ContactDetail',
                params: {
                  id: this.dataForm.mainId || 0
                }
              })
              window.open(routeData.href, '_blank')
            }
          })
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
        }
      } else if (_.get(response, 'data.isExist', false)) {
        this.$swal({
          title: 'Cập nhật contact không thành công, Số điện thoại đã tồn tại!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Xem contact',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(result => {
          if (result.value) {
            return this.$router.push({
              name: 'ContactDetail',
              params: {
                id: _.get(response, 'data.contactId', null)
              }
            });
          }
        });
      } else if (_.get(response, 'data.existProcessingOrder', false)) {
        this.$swal({
          title: 'Cập nhật contact thành công, lưu ý: Contact đang có đơn hàng ở trạng thái T3/C3/T4/C4, vui lòng kiểm tra đơn hàng',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Danh sách đơn hàng',
          closeOnConfirm: false,
          cancelButtonText: 'Huỷ Bỏ'
        }).then(result => {
          if (result.value) {
            return this.$router.push({
              name: 'ContactOrderList',
              params: {
                id: _.get(response, 'data.id', null)
              }
            });
          }
        });
      } else {
        this.$swal({
          title: 'Cập Nhật Khách Hàng Thành Công!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          // this.$router.go(this.$router.currentRoute);
          this.getContactDetail(),
          this.getProductGroups(),
          this.getUsers(),
          this.getContactSources(),
          this.getContactColumns(),
          this.getContactStatusList()
        });
      }
    },
    clickCancel() {
      this.$router.push({
        name: 'ContactList'
      });
    },
    async getContactDetail() {
      const respond = await ContactRepository.detail(this.$route.params.id);
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        this.loadedContact = true;
        const dataContact = _.get(respond, 'data', {});
        const contactSourceIds = _.get(dataContact, 'contactSources', []).map(
          contactSource => contactSource.id
        );
        this.listPhoneRelated = dataContact.phoneRelated.join(", ")
        let sources = Array.from(dataContact.contactSources, item => item.name)
        if (this.checkSources.some(val => sources.indexOf(val) > -1)) {
         this.showChat = true
        }
        let groupIds = [];
        if (!Array.isArray(dataContact.customers)) {
          dataContact.customers = [];
        }
        const customers = dataContact.customers.map(customer => {
          const customerTemp = customer;
          customerTemp.phones = customer.phones.map(data => data.phoneNumber);
          customerTemp.courseRegister = [];
          if (customer.isMainCustomer && customer.fullName === '') {
            customerTemp.fullName = customerTemp.mobile;
          }
          customerTemp.customerId = customerTemp.id;

          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
            customerTemp.phones.shift();
          }

          customerTemp.isNew = false;

          _.get(customerTemp, 'contactColumnValues', []).forEach(
            dataAttribute => {
              customerTemp[dataAttribute.columnId] = dataAttribute.value;
            }
          );

          return customerTemp;
        });
        const mainCustomer = customers.find(
          customer => customer.isMainCustomer
        ) || {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        };
        let contactColumnValues = {};
        _.get(dataContact, 'contactColumnValues', []).forEach(dataAttribute => {
          contactColumnValues[dataAttribute.columnId] = dataAttribute.value;
        });
        if(!dataContact.contactStatus) {
          dataContact.contactStatus = {}
        }
        this.dataForm = {
          ...dataContact,
          contactSourceIds,
          groupIds,
          customers: [
            mainCustomer,
            ...customers.filter(customer => !customer.isMainCustomer)
          ],
          ...contactColumnValues,
          isDetail: true,
          productGroups: _.get(dataContact,'groups', []).map(dataGroup => dataGroup.id),
        };
      } else {
      }
    },
    async getProductGroups() {
      const respond = await ProductGroupRepository.list({
        limit: 100,
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      if (_.get(respond, 'success', false)) {
        this.productGroups = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getContactSources() {
      const respond = await ContactSourceRepository.list({
        limit: 100,
        status: 'active'
      });
      if (_.get(respond, 'success', false)) {
        this.contactSources = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getUsers() {
        const res = await OrganizationMachineRepository.listUserContactAdvise({
          status: 'active',
          schoolLevelId: this.$store.state.module.schoolLevelId,
          typeId: this.$store.state.module.typeId
        })

        if (res.success) {
          let listUsers = _.get(res, 'data', [])
          const groupUsers = [];
          listUsers.forEach(ministry => {
            const { users = [] } = ministry;
            if (users.length) {
              groupUsers.push({
                header: ministry.name,
                name: _.get(ministry, 'name'),
                ministryId: ministry.id,
              });
              users.forEach(user => {
                groupUsers.push({
                  fullName: _.get(user, 'fullName'),
                  group: _.get(ministry, 'name'),
                  id: user.id,
                  avatar: _.get(user, 'avatar.filePath'),
                  ministryId: ministry.id,
                });
              });
            }
          });
          this.users = groupUsers;
        } else {
          this.$swal({
            title: 'Lỗi!',
            text: _.get(res, 'message', '')
          })
        }
    },
    async getListSchoolLevel() {
      if(this.$store.state.listSchoolLevelDrawer) {
        this.schoolLevels  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
        return
      }

      const res = await SchoolLevelRepository.listTypeSchoolLevel()
      if (res.success) {
        this.schoolLevels = _.get(res, 'data', [])
      } else {
        this.schoolLevels = []
      }
    },
    async getListType() {
      const res = await TypeRepository.list({limit: 1000})
      if (res.success) {
        this.types = _.get(res, 'data', [])
      } else {
        this.types = []
      }
    },
  }
};
</script>
